import { useStorage } from '@hooks'
import { sendGAEvent } from '@next/third-parties/google'
import { useState, useEffect } from 'react'

export default function useFavotire(stationId: string) {
  const [isFavorite, setIsFavorite] = useState(false)
  const { get, add, remove } = useStorage("favorites")
    
  const toggle = () => {
    if (isFavorite) {
      remove(stationId)
      setIsFavorite(false)
    } else {
      add(stationId)
      setIsFavorite(true)
      sendGAEvent('event', 'favorite', { screen_name: stationId })
    }
  }


  useEffect(() => {
      const favorites = (get() || []) as string[]
      if (favorites.includes(stationId))
          setIsFavorite(true)
  }, [])

  return {
    toggle, isFavorite
  }
}
